import React from 'react'
import { Component, LocaleCode } from '../types/component'

interface DividerProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function Divider({ component, style }: DividerProps) {
  const config = component.config as any

  const type = config.type || 'line'
  const thickness = config.thickness || 1
  const width = config.width || '100%'
  const text = config.text

  const getDividerStyle = (): React.CSSProperties => {
    const baseStyle: React.CSSProperties = {
      width,
      margin: '0 auto',
    }

    if (type === 'wave') {
      return {
        ...baseStyle,
        height: `${thickness * 4}px`,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='20' viewBox='0 0 100 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 10 Q 25 0, 50 10 T 100 10' stroke='${encodeURIComponent(
          (style as any).borderColor || style.color || '#e5e7eb'
        )}' stroke-width='${thickness}' fill='none'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat-x',
        backgroundSize: '100px 20px',
      }
    }

    if (type === 'gradient') {
      return {
        ...baseStyle,
        height: `${thickness}px`,
        background: `linear-gradient(to right, transparent, ${(style as any).borderColor || style.color || '#e5e7eb'}, transparent)`,
      }
    }

    return {
      ...baseStyle,
      borderTop: `${thickness}px ${type === 'line' ? 'solid' : type} ${(style as any).borderColor || style.color || '#e5e7eb'}`,
    }
  }

  return (
    <div className="w-full flex items-center py-5">
      {text ? (
        <div className="flex items-center w-full gap-4">
          <div style={getDividerStyle()} className="flex-1" />
          <span className="text-sm font-medium whitespace-nowrap" style={{ color: style.color }}>
            {text}
          </span>
          <div style={getDividerStyle()} className="flex-1" />
        </div>
      ) : (
        <div style={getDividerStyle()} />
      )}
    </div>
  )
}
